// src/pages/Inicial.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Card from "../components/Card/Card";
import SecaoAutomatica from "../components/Secoes/SecaoAutomatica";
import HeroCarousel from "../components/Hero/HeroCarousel";
import { useProjetosBanco } from "../hooks/useProjetosComBanco";

import ImagemPrincipal from "../img/Image-home.png";
import SobreCelular from "../img/Sobre_Celular.svg";
import SobreYoutube from "../img/Sobre_Youtube.svg";
import SobreLampada from "../img/Sobre_Lampada.svg";


function Inicial({ filtro, pesquisa }) {

    const [secaoAtiva, setSecaoAtiva] = useState(null);
    const todosProjetos = useProjetosBanco();

    const navigate = useNavigate();

    const location = useLocation();

    /* Ã°Å¸â€Â¹ Scroll automÃƒÂ¡tico quando vier com ÃƒÂ¢ncora (#secao-...) */
    useEffect(function () {
        if (location.hash) {
            const id = location.hash.replace("#", "");

            setTimeout(function () {
                const elemento = document.getElementById(id);

                if (elemento) {

                    const alturaViewport = window.innerHeight;
                    
                    const offset = alturaViewport * 0.4;

                    const posicao =
                        elemento.getBoundingClientRect().top +
                        window.scrollY -
                        offset;

                    window.scrollTo({
                        top: posicao,
                        behavior: "smooth"
                    });
                }
            }, 100);
        }
    }, [location]);

    useEffect(function () {

        const secoes = document.querySelectorAll("[data-secao]");

        const observer = new IntersectionObserver(
            function (entries) {

                let secaoMaisVisivel = null;
                let maiorRatio = 0;

                entries.forEach(function (entry) {
                    if (entry.intersectionRatio > maiorRatio) {
                        maiorRatio = entry.intersectionRatio;
                        secaoMaisVisivel = entry.target;
                    }
                });

                if (secaoMaisVisivel) {
                    const id = secaoMaisVisivel.getAttribute("data-secao");
                    setSecaoAtiva(id);
                }
            },
            {
                root: null,
                rootMargin: "-40% 0px -40% 0px",
                threshold: 0
            }
        );

        secoes.forEach(function (secao) {
            observer.observe(secao);
        });

        return function () {
            observer.disconnect();
        };

    }, []);

    const handleCardClick = (id) => {
        navigate(`/projeto/${id}`);
    };

    // FunÃƒÂ§ÃƒÂ£o de filtragem global
    function filtrarProjetos() {
        // Combinar projetos do JSON e do banco
        let projetos = [...todosProjetos];

        // Se houver pesquisa, prioriza ela
        if (pesquisa && pesquisa.trim() !== "") {
            return projetos.filter(
                (proj) =>
                    proj.titulo.toLowerCase().includes(pesquisa.toLowerCase()) ||
                    proj.descricao.toLowerCase().includes(pesquisa.toLowerCase()) ||
                    (proj.tags || []).some((tag) =>
                        String(tag).toLowerCase().includes(pesquisa.toLowerCase())
                    )
            );
        }

        // Se houver filtro ativo
        if (filtro && filtro !== "todos") {
            return projetos.filter((proj) =>
                proj.tags.some((t) => String(t).toLowerCase() === filtro.toLowerCase())
            );
        }

        // Caso contrÃƒÂ¡rio Ã¢â€ â€™ sem filtros/pesquisa
        return null;
    }

    const projetosFiltrados = filtrarProjetos();


    const idsHero = todosProjetos.slice(0, 3).map((projeto) => projeto.id);

    const slidesHero = todosProjetos
        .filter(function (projeto) {
            return idsHero.includes(projeto.id);
        })
        .map(function (projeto) {
            return {
                imagem: ImagemPrincipal,
                projetoId: projeto.id,
                titulo: projeto.titulo
            };
        });

    return (
        <div>
            <HeroCarousel slides={slidesHero} />

            {/* CONTEÃƒÅ¡DO COM RESPIRO */}

            <div className="pagina-inicial-conteudo">

                {projetosFiltrados ? (
                    // Ã°Å¸â€Â¹ Lista filtrada simples
                    <div className="cards-container">
                        {projetosFiltrados.map((projeto) => (
                            <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
                        ))}
                    </div>
                ) : (
                    // Ã°Å¸â€Â¹ Estado inicial (sem filtros/pesquisa) Ã¢â€ â€™ renderiza seÃƒÂ§ÃƒÂµes
                    <>
                        {/* ========================= SOBRE ========================= */}

                        <section className="secao-sobre">

                            <div className="sobre-container">

                                <div className="sobre-coluna">

                                    <div className="sobre-icone">
                                        <img src={SobreCelular} alt="Dispositivos mÃƒÂ³veis" />
                                    </div>

                                    <div className="sobre-conteudo">

                                        <h3 className="sobre-titulo">
                                            Experiencias imersivas para o ensino
                                        </h3>

                                        <p className="sobre-texto">
                                            Explore conteúdos em Realidade Virtual, Realidade Aumentada e vi­deos 360i, que ampliam a compreensão dos alunos por meio de experiências visuais e interativas.
                                        </p>

                                        <div className="sobre-linha"></div>

                                    </div>

                                </div>


                                <div className="sobre-coluna">

                                    <div className="sobre-icone">
                                        <img src={SobreLampada} alt="Ideias e tecnologia" />
                                    </div>

                                    <div className="sobre-conteudo">

                                        <h3 className="sobre-titulo">
                                            Conteúdos organizados por áreas do conhecimento
                                        </h3>

                                        <p className="sobre-texto">
                                            Encontre materiais categorizados por áreas técnicas, facilitando a busca por recursos alinhados aos temas trabalhados em aula.
                                        </p>

                                        <div className="sobre-linha"></div>
                                    </div>

                                </div>


                                <div className="sobre-coluna">

                                    <div className="sobre-icone">
                                        <img src={SobreYoutube} alt="ConteÃƒÂºdos multimÃƒÂ­dia" />
                                    </div>
                                    <div className="sobre-conteudo">
                                        <h3 className="sobre-titulo">
                                            Recursos prontos para usar
                                        </h3>

                                        <p className="sobre-texto">
                                            Acesse imagens, vi­deos e aplicações interativas que podem ser visualizados diretamente na plataforma ou baixados para utilizados como apoio as atividades pedagógicas.
                                        </p>

                                        <div className="sobre-linha"></div>
                                    </div>

                                </div>

                            </div>

                        </section>

                        <div
                            className="secao-wrapper"
                            data-secao="rv"
                            id="secao-rv"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "rv" ? "ativa" : ""}`}>
                                    RV
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag="RV"
                                    projetos={todosProjetos}
                                    ativa={secaoAtiva === "rv"}
                                />
                            </div>
                        </div>

                        <div
                            className="secao-wrapper"
                            data-secao="ra"
                            id="secao-ra"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "ra" ? "ativa" : ""}`}>
                                    RA
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag="RA"
                                    projetos={todosProjetos}
                                    ativa={secaoAtiva === "ra"}
                                />
                            </div>
                        </div>

                        <div
                            className="secao-wrapper"
                            data-secao="video360"
                            id="secao-video360"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "video360" ? "ativa" : ""}`}>
                                    {"V\u00cdDEO 360"}
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag={"Vídeo 360"}
                                    projetos={todosProjetos}
                                    ativa={secaoAtiva === "video360"}
                                />
                            </div>
                        </div>

                        <div
                            className="secao-wrapper"
                            data-secao="video360i"
                            id="secao-video360i"
                        >
                            <div className="secao-lateral">
                                <span className={`secao-tag ${secaoAtiva === "video360i" ? "ativa" : ""}`}>
                                    {"V\u00cdDEO 360i"}
                                </span>
                                <div className="secao-linha"></div>
                            </div>

                            <div className="secao-conteudo">
                                <SecaoAutomatica
                                    tag={"Vídeo 360i"}
                                    projetos={todosProjetos}
                                    ativa={secaoAtiva === "video360i"}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Inicial;



